
import { Component, Injector, OnDestroy, OnInit } from "@angular/core";
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ROLE_GESTOR_ENVIO, ROLE_GESTOR_CONSULTA } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { LimiteAgenteFinanceiro } from "src/app/model/limite-agente-financeiro.model";
import { Tranche } from "src/app/model/tranche.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { AgenteFinanceiroService } from "src/app/shared/services/agente-financeiro.service";
import { LimiteService } from "src/app/shared/services/limite.service";
import { TrancheService } from "src/app/shared/services/tranche.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-limite-detalhe',
    templateUrl: './limite-detalhe.component.html',
    styleUrls: ['./limite-detalhe.component.scss'],
    standalone: false
})
export class LimiteDetalheComponent extends BaseEntityComponent<LimiteAgenteFinanceiro> implements OnInit, OnDestroy {

  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private tranches: Tranche[] = [];
  private trancheSelecionada: Tranche;
  public click: boolean = false;
  private readonly destroy$ = new Subject();

  constructor(
    protected injector: Injector,
    private permissaoService: PermissaoService,
    private loadingService: BnLoadingService,
    private agenteService: AgenteFinanceiroService,
    private limiteService: LimiteService,
    private trancheService: TrancheService,
  ) {
	  super(limiteService);
    this.config.rotaLista = '/limite/pesquisa';
    this.config.bloquearTelaAoRecuperarModelo = true;
  }

  ngOnInit() {

    this.modoEdicao = false;
    this.permissaoService.getPermissoesUsuarioAutenticado().pipe(takeUntil(this.destroy$)).subscribe((resp: any) => {
    	if (resp && resp[ROLE_GESTOR_CONSULTA] || resp && resp[ROLE_GESTOR_ENVIO]) {
        this.agenteService.getAgentesFinanceiros().pipe(takeUntil(this.destroy$)).subscribe (agentes => {
          this.agentesFinanceiros = agentes;
          this.agentesFinanceiros = this.agentesFinanceiros
            .sort ((elemento1, elemento2) => (elemento1.nome > elemento2.nome) ? 1 : -1);
        });
        this.trancheService.getTranches().pipe(takeUntil(this.destroy$)).subscribe (tranches => this.tranches = tranches);
        setTimeout(() => this.recuperarModelo(), 0);
    	}
    });
  }

  atribuiTranche(ideTranche) {
    this.trancheSelecionada = this.tranches.find(tranche => tranche.id == ideTranche);
  }

  private atribuiModel(model) {
    super.setModel(model);
  }

  recuperarModelo() {

    const state = history.state;

    if (state?.idLimiteAdicional) {

      this.modoEdicao = true;

      this.agenteService
        .buscaLimiteAdicionalFg2(
          state.cnpjAgente,
          state.ideTranche,
          state.idLimiteAdicional
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe(resp => {

          this.atribuiModel(resp);

          this.atribuiTranche(this.model.ideTranche);

          this.loadingService.liberaTela();
        });

      return;
    }

    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {

        const idLimiteAgente = params['id'];

        if (idLimiteAgente) {

          this.modoEdicao = true;

          this.limiteService
            .getLimiteComHistoricoCarregado(idLimiteAgente)
            .subscribe(resp => {

              this.atribuiModel(resp);

              this.atribuiTranche(this.model.ideTranche);

              this.loadingService.liberaTela();
            });
        }
      });
  }
}


